import * as React from "react";
import TextDataInput from "../textDataInput/TextDataInput";
import { IRepertoireStateKeys } from "../../types/IRepertoireStateKeys";
import PaginationView from "../paginationView/PaginationView";
import {
    ADD_NEW_ACTION,
    REMOVE_ACTION,
    SEARCH_VIEW,
    SEARCH_VIEW_CONTRIBUTORS,
    CONTRIBUTORS_KEY,
    ADMINISTERED_BY_KEY,
    APPLICABLE_WORKS_KEY,
    AGREEMENT_CARVEOUTS_KEY,
    AGREEMENTS_IP_KEY,
    MATCHING_REPERTOIRE_WORKS_KEY,
    PRODUCT_WORKS_KEY,
    PRODUCT_WORKS_REPERTOIRE_STATE_KEY,
    PRODUCT_CONTRIBUTORS_KEY,
    COMPONENTS_KEY,
    COMPONENTS_WORKS_REPERTOIRE_STATE_KEY,
    EDITABLE_FIELDS,
    EDITABLE_FIELDS_GRID,
    SEQUENCE_FIELD,
    MATCHING_REPERTOIRE_PRODUCTS_KEY,
    USAGE_MATCHING_WORKS_SECTION_KEY, USAGESEARCH_VIEW, MATCHINGWORKS_KEY, MATCHINGPRODUCTS_KEY,
    USAGE_MATCHING_PRODUCTS_SECTION_KEY, ARTISTS_KEY, PRODUCT_PERFORMERS_KEY,
    IP_REPRESENTATION_KEY,
    TERRITORY_SELECTION_VIEW,
    DRAFT_AGREEMENTS_PAGE_VIEW,
    POOL_SELECTION_VIEW,
    USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY,
    USAGE_MAINTENANCE_COMMENTS_MODAL,
    AGREEMENT_CARVEOUT_PRODUCTS_KEY,
    EDITABLE_DATA_FIELDS_CONFIGURATION_GRID,
    TITLES_KEY,
    PAGINATION,
    MODAL_VIEW,
    POOL_WEIGHT_SETTINGS_KEY
} from "../../Consts";
import { createCopyOfTableContents } from "../../services/TableFunctions";
import { IRepertoireField } from "../../types/IRepertoireField";
import IRepertoireComponentDataItem from "../../../redux/types/IRepertoireComponentDataItem";
import { hideModal, showWorkSubmission } from "../../../redux/reducers/ModalReducer";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { ITableAction } from "../../types/ITableAction";
import { addTab, clearModalSearchResults, updateWorkField, enableCustomField, addUsageDetailsShareIPRow, addUsageDetailsRowData } from "../../../redux/reducers/RepertoireReducer";
import { DataSource } from "../../types/DataSource";
import { ISubmissionPromptViewModalProps } from "../modalViews/workSubmission/WorkSubmission";
import { ITabReduxItem } from "../../../redux/types/ITabReduxItem";
import { IContributorItem } from "../../types/IContributorItem";
import { Dictionary } from "../../../core/types/Dictionary";
import { If } from "../../../core/components/If";
import { IAgreementShareDisplayConfiguration } from "../../types/IAgreementShareDisplayConfiguration";
import { ITreeData } from "../../types/ITreeData";
import { FieldOptions } from "../fieldOptions/FieldOptions";
import { IDistribution } from "../../types/usageTypes/IDistribution";
import { IIpLicensingRepresentation } from "../../types/IIpLicensingRepresentation"
import { DRAFT_AGREEMENTS_COMMENTS_STATE_KEY } from "../../../membersportal/Consts";
import { IUsagePoolDatesAndDimensions } from "../../types/usageTypes/IUsagePoolDatesAndDimensions";
import { IUsagePool } from "../../types/usageTypes/IUsagePool";
import { IUsagePoolState } from "../../../redux/types/IUsagePoolState";
import ListenToShortCutKeysDataGridTable, { DO_NOT_SHOW_MODAL } from "./ListenToShortCutKeysDataGridTable";
import { IWorksSearchQuery } from "../../types/IWorksSearchQuery";
import { EXTERNAL_SVG, RIGHT_ARROW_SVG } from "../../IconConsts";
import { IAgreementStateKeys } from "../../../redux/types/IAgreementState";
import { getNewItem, openModalOrNewTab, removeTableItem } from "./utils/dataGridTableActionUtils";
import { getTableSections } from "./utils/dataGridTableRenderTableSections";
import { IUsageDetailsRowData } from "../../types/usageTypes/IUsageDetailsRowData";
import { IResultsPerPage } from "../../../redux/types/IResultsPerPage";
import { IActiveAccordion } from "../../../redux/types/IActiveAccordion";
import { FormatFields } from "../../../redux/types/FormatFields";
import IMembersPortalComponentDataItem from "../../../redux/types/IMembersPortalComponentDataItem";
import { changeTableData as handleTableDataChange } from "./utils/dataGridTableChangeDataUtils";
import {
    renderGroupedActions as renderGroupedRowActions,
    renderRowAction as renderTableRowAction,
} from "./utils/dataGridTableRowActionUtils";
import { renderTableAction as renderDataGridTableAction } from "./utils/dataGridTableActionsRenderer";
import { getHeaderSections as buildHeaderSections } from "./utils/dataGridTableHeaderSectionsUtils";
import { renderTableContents as buildTableContents } from "./utils/dataGridTableContentsRenderer";

export interface IDataGridTableProps {
    tableContents: any;
    paginatedTableContents?: any;
    changeData?: (value: any, name: IRepertoireStateKeys, objectKey?: string, ipRepresentationsIdsToRemove?: number[]) => void;
    sortData?: (value: any, name: IRepertoireStateKeys) => void;
    dependentRowAction?: (value: any, event?: React.MouseEvent) => void;
    componentInstance: string;
    dataGridTableData: IRepertoireComponentDataItem;
    tableActions?: ITableAction[];
    stateKey: IRepertoireStateKeys;
    showModal?: (
        modalContent: string,
        modalComponentInstance: string,
        modalProps: any,
        displayModalCloseButton: boolean,
        title: string,
        modalMessage?: string,
        isReadOnly?: boolean,
        key?: string,
        index?: number
    )=>void;
    clearModalSearchResults?: typeof clearModalSearchResults | (() => void);
    lookupValues?: ILookupDictionary;
    addTab?: typeof addTab;
    showDropdownsAsCodes?: boolean
    showRowNumber: boolean;
    setTypeGroup?: string;
    activeSetType?: string;
    dataSource?: DataSource;
    isReadOnly?: boolean;
    openInNewTab?: (openItem: any) => void;
    openInSplitScreen?: (openItem: any) => void;
    showWorkSubmissionDetail?: typeof showWorkSubmission;
    hideModal?: typeof hideModal;
    tabs?: ITabReduxItem[];
    activeTab?: number;
    currentUser?: string;
    groupActionClick?: (action: any, tableContentItem: any) => void;
    contributorConfiguration?: string;
    updateContributorRelationships?: (value: string, contributors: IContributorItem[], rowIndex: number) => void;
    updateWorkField?: typeof updateWorkField;
    customFields?: number[];
    enableCustomField?: typeof enableCustomField;
    showFieldsModal?: () => void;
    agreementShareDisplayOptions?: IAgreementShareDisplayConfiguration
    shareDecimalsToDisplay?: number;
    isExpandable?: boolean;
    usageType?: string;
    lookupSources?: ITreeData[];
    addNewAccount?: () => void;
    poolCodes?: string[];
    distributionCodes?: string[];
    distributions?: IDistribution[];
    clearAllRowsButThis?: (value: any) => void;
    expandedWorkResults?: number[];
    expandedProductResults?: number[];
    expandMatchingWork?: (index: number) => void;
    expandMatchingProduct?: (index: number) => void;
    expandUsageDetailRow?: (index: number) => void;
    allowMultiSelectChbk?: boolean;
    isBulkCheckboxActive?: boolean;
    changeBulkCheckbox?: (value: boolean) => void;
    incrementTempID?: () => void;
    entity?: any;
    onClickAddUsageDetails?: (index: number) => void;
    addUsageDetailsShareIPRow?: typeof addUsageDetailsShareIPRow;
    addUsageDetailsRowData?: typeof addUsageDetailsRowData;
    onUpdateUsageRowDetails?: (value: IUsageDetailsRowData[], fieldName: string, index: number) => void;
    portalType?: string;
    resetMessageBanner?: () => void;
    openWorkFlow?: boolean;
    datesAndDimensions?: IUsagePoolDatesAndDimensions[];
    usagePoolsSearchResults?: IUsagePool[];
    poolCode?: string;
    sources?: ITreeData[];
    getUsagePool?: (poolId: number, matchingSources: ITreeData[]) => void;
    pool?: IUsagePoolState;
    isExpandedUsageMatchingSection?: boolean;
    expandedUsageDetailsRow?: number[];
    creationClassOptions?: any[];
    customer?: string;
    searchWorks?: (query: IWorksSearchQuery, modalOpen: boolean) => void;
    updateDraftAgreementWorkField?: (value: any, fieldName: IAgreementStateKeys, index?: number) => void;
    mergeActionClick?: (tableContentItem: any) => void;
    isBackendSearchEnabled?: boolean;
    onBackendSearch?: (value: string, e?: any) => void;
    checkableColumns?: string[];
    checkedColumns?: string[];
    toggleHeaderCheckbox?: (fieldName: string, isChecked: boolean) => void;
    customComponentOnClickAdd?: () => void;
    onClickCopy?: () => void;
    isRowSelectionEnabled?: boolean;
    currentPage?: number;
    resultsPerPage?: number;
    showRowName?: boolean;
    allResultsPerPage?: IResultsPerPage[];
    updateUserPreferences?: (allResultsPerPage: IResultsPerPage[], activeAccordions: IActiveAccordion[], newActiveAccordionName?: string, accordionExpanded?: boolean, componentName?: string, indexOfFirstResult?: number, indexOfLastResult?: number, resultsPerPage?: number, repertoireSection?: string) => void;
    getRegisteredWorkDetails?: (dataSource: string, registeredWorksID: number, lookupValues: ILookupDictionary, registeredWorkMaintenanceDataViewData: IMembersPortalComponentDataItem, formats?: FormatFields[]) => void;
    registeredWorksMaintenanceGeneralDataViewData?: IMembersPortalComponentDataItem;
    isProductMaintenanceAccordionCore?: boolean;
}

interface IDataGridTableState {
    activeSortHeaderSection: string;
    focusedRow: number;
    searchModalName: string;
    isRemoveAction: boolean;
    indexOfFirstResult: number;
    indexOfLastResult: number;
    currentPage: number;
    resultsPerPage: number;
    checkedColumns: string[];
}

export default class DataGridTable extends React.PureComponent<
    IDataGridTableProps,
    IDataGridTableState
> {
    componentRef;
    constructor(props: IDataGridTableProps) {
        super(props);        

        this.componentRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);

        const componentResultsPerPage = props?.allResultsPerPage?.find(pd => pd.repertoireSection === props?.componentInstance);
        const resultsPerPage = componentResultsPerPage?.resultsPerSection ?? 50;

        this.state = {
            activeSortHeaderSection: undefined,
            focusedRow: null,
            searchModalName: DO_NOT_SHOW_MODAL,
            isRemoveAction: false,
            indexOfFirstResult: 0,
            indexOfLastResult: 0,
            currentPage: 1,
            resultsPerPage: resultsPerPage,
            checkedColumns: props.checkedColumns || [],
        };

        const { usagePoolsSearchResults, poolCode, sources, getUsagePool } = this.props;
        if (usagePoolsSearchResults) {
            const findX = usagePoolsSearchResults.find(x => x.poolCode === poolCode)
            if (findX)
                getUsagePool(findX.poolId, sources);
        }
    }

    setTheSearchModalTypeShortCutKeyListening = (stateKey) => {
        const { dataSource } = this.props;
        switch (stateKey) {
            case CONTRIBUTORS_KEY:
                this.setState({ searchModalName: CONTRIBUTORS_KEY });
                return;
            case PRODUCT_CONTRIBUTORS_KEY:
                this.setState({ searchModalName: PRODUCT_CONTRIBUTORS_KEY });
                return;
            case APPLICABLE_WORKS_KEY:
                this.setState({ searchModalName: APPLICABLE_WORKS_KEY })
            case MATCHING_REPERTOIRE_WORKS_KEY:
                this.setState({ searchModalName: MATCHING_REPERTOIRE_WORKS_KEY })
                return;
            case MATCHING_REPERTOIRE_PRODUCTS_KEY:
                this.setState({ searchModalName: MATCHING_REPERTOIRE_PRODUCTS_KEY })
                return;
            case ARTISTS_KEY:
                if (dataSource === DataSource.Intray) {
                    this.setState({ searchModalName: ARTISTS_KEY })
                    return;
                }
                this.setState({ searchModalName: DO_NOT_SHOW_MODAL })
                return;
            case PRODUCT_PERFORMERS_KEY:
                if (dataSource === DataSource.Intray) {
                    this.setState({ searchModalName: PRODUCT_PERFORMERS_KEY })
                    return;
                }
                this.setState({ searchModalName: DO_NOT_SHOW_MODAL })
                return;
            case AGREEMENTS_IP_KEY:
            case ADMINISTERED_BY_KEY:
                this.setState({ searchModalName: AGREEMENTS_IP_KEY })
                return;
            default:
                this.setState({ searchModalName: DO_NOT_SHOW_MODAL })
        }
    }

    handleClickOutside(event: any) {
        if (this.componentRef.current && !this.componentRef.current.contains(event.target)) {
            this.setState({ searchModalName: DO_NOT_SHOW_MODAL })
            this.setState({ focusedRow: null })
            return;
        }
    }

    componentDidMount() {
        const { componentInstance, dataGridTableData } = this.props;        
        this.setTheSearchModalTypeShortCutKeyListening(componentInstance)
        const filteredFields = dataGridTableData && dataGridTableData?.fields.filter(field => field.componentInstance === componentInstance);
        if (filteredFields?.filter(field => field.fieldType === REMOVE_ACTION).length > 0) {
            this.setState({ isRemoveAction: true });
        }        
    }

    onRowClick = (rowNumber) => {

        const { componentInstance, expandUsageDetailRow } = this.props;
        this.setState({ focusedRow: rowNumber });
        this.setTheSearchModalTypeShortCutKeyListening(componentInstance);
        if (expandUsageDetailRow) {
            expandUsageDetailRow(rowNumber);
        }
    }

    addRowShortCutKeys = () => {
        const { focusedRow } = this.state;

        const { tableActions } = this.props;
        if ((focusedRow === 0 || focusedRow) && tableActions && tableActions.filter(action => action.name === ADD_NEW_ACTION)?.length > 0) {
            this.onClickAdd();
        }
    }

    deleteRowShortCutKeys = () => {
        const { focusedRow, isRemoveAction } = this.state;
        const { tableContents } = this.props;
        if ((focusedRow === 0 || focusedRow) && isRemoveAction) {
            this.onClickRemove(tableContents[focusedRow])
        }
    }

    showSearchModalShortCutKey = () => {
        const { focusedRow, searchModalName } = this.state;
        const { tableContents } = this.props;

        if (searchModalName !== DO_NOT_SHOW_MODAL) {
            this.showSearchModal(tableContents[focusedRow], searchModalName)
        }

    }

    public ascending: boolean = false;
    public ipRepresentationsIdsToRemove: number[] = [];
    public updatedIpLicensingRepresentations: IIpLicensingRepresentation[] = [];

    sortTableByColumn = (section: string) => {
        const { activeSortHeaderSection, currentPage, resultsPerPage } = this.state;
        const { tableContents, sortData, stateKey, componentInstance, tabs, activeTab, activeSetType } = this.props;
        let fullTableContentsCopy: Dictionary<IContributorItem[]>;
        let tableContentsCopy: any;

        const workContributors = tabs?.[activeTab]?.workMaintenanceState?.work?.contributors;

        if (activeSetType == 'iced' && workContributors && !workContributors.hasOwnProperty('iced')) {
            workContributors['iced'] = tableContents;
        }

        if (stateKey === SEARCH_VIEW_CONTRIBUTORS && workContributors) {
            fullTableContentsCopy = workContributors;
            tableContentsCopy = fullTableContentsCopy[activeSetType];
        }
        else {
            tableContentsCopy = JSON.parse(JSON.stringify(tableContents));
        }

        if (activeSortHeaderSection !== section) {
            this.ascending = false;
        }
        if (tableContentsCopy) {
            tableContentsCopy.sort((a: any, b: any) => {
                const valA = a[section]?.value ?? a[section] ?? "";
                const valB = b[section]?.value ?? b[section] ?? "";
                
                const numA = parseFloat(valA);
                const numB = parseFloat(valB);

                let comparison = 0;
                if (!isNaN(numA) && !isNaN(numB)) {
                    comparison = numA - numB;
                } else {
                    comparison = valA.toString().localeCompare(valB.toString(), undefined, { numeric: true });
                }

                return this.ascending ? comparison : -comparison;
            });
        }

        this.setState({ activeSortHeaderSection: section });
        if (componentInstance === SEARCH_VIEW_CONTRIBUTORS && fullTableContentsCopy) {
            fullTableContentsCopy[activeSetType] = tableContentsCopy;
            sortData(fullTableContentsCopy, stateKey);
        } else {
            sortData(tableContentsCopy, stateKey);
        }
        this.updateContentsTable((currentPage - 1) * resultsPerPage, ((currentPage - 1) * resultsPerPage) + resultsPerPage, resultsPerPage, currentPage);
        this.ascending = !this.ascending;
    };

    changeTableData = (
        value: any,
        stateKey: IRepertoireStateKeys,
        objectKey: string,
        rowIndex: number,
        componentInstance?: string,
        newOrderValue?: string
    ) => {
        const { changeData, tableContents, updateContributorRelationships, datesAndDimensions, checkableColumns, toggleHeaderCheckbox } = this.props;
        handleTableDataChange({
            value,
            stateKey,
            objectKey,
            rowIndex,
            componentInstance,
            newOrderValue,
            changeData,
            tableContents,
            updateContributorRelationships,
            datesAndDimensions,
            checkableColumns,
            toggleHeaderCheckbox,
        });
    };

    changeTableDataForMultiSelect = (value: any, fieldName: string) => {
        const { tableContents, changeBulkCheckbox } = this.props;
        changeBulkCheckbox(value);
        for (let i = 0; i < tableContents.length; i++) {
            tableContents[i][fieldName].value = value;
        }
    };

    handleHeaderCheckboxChange = (fieldName: string, isChecked: boolean) => {
        this.setState(
            prevState => ({
                checkedColumns: isChecked
                    ? [...prevState.checkedColumns, fieldName]
                    : prevState.checkedColumns.filter(column => column !== fieldName),
            }),
            () => {
                const { tableContents, toggleHeaderCheckbox } = this.props;
                if (tableContents?.length) {
                    toggleHeaderCheckbox(fieldName, isChecked);
                    tableContents.forEach(row => row[fieldName].value = isChecked);
                }
            }
        );
    };

    toggleHeaderCheckbox = (fieldName: string, isChecked: boolean) => {
        const { toggleHeaderCheckbox } = this.props;
        this.setState(
            ({ checkedColumns }) => ({
                checkedColumns: isChecked
                    ? [...checkedColumns, fieldName]
                    : checkedColumns.filter(column => column !== fieldName),
            }),
            () => toggleHeaderCheckbox(fieldName, isChecked)
        );
    };

    changeDataForLivePerformance = (data: string) => {
        if (data === "Program Start Date" || data === "Program End Date")
            return data.replace("Date", "Time");
        return data
    }

    onClickRemove = (tableContentItem: any) => {
        const { changeData, stateKey, tableContents, tabs, activeTab, componentInstance } = this.props;
        removeTableItem(changeData, stateKey, tableContents, tabs, activeTab, componentInstance, this.ipRepresentationsIdsToRemove, tableContentItem);
    }

    onClickOpen = (field: IRepertoireField, tableContentItem: any) => {
        const { showModal, openInNewTab, isReadOnly } = this.props;
        openModalOrNewTab(field.componentInstance, tableContentItem, field.data, showModal, openInNewTab, isReadOnly);
    }

    updateIpRepresentationsIdsToRemove = (tableContentItem: any): number[] => {
        const { tabs, activeTab } = this.props;

        if (activeTab) {
            this.ipRepresentationsIdsToRemove = tabs[activeTab].interestedPartyMaintenanceState?.representationIds ?? [];
        }
        else {
            this.ipRepresentationsIdsToRemove = [];
        }

        let ipLicensingRepresentation: any = tableContentItem ? tableContentItem as IIpLicensingRepresentation : undefined;

        if (ipLicensingRepresentation !== undefined || ipLicensingRepresentation.id !== undefined) {
            this.ipRepresentationsIdsToRemove.push(ipLicensingRepresentation.id);
        }

        return this.ipRepresentationsIdsToRemove;
    }

    onClickAdd = () => {
        const { 
            changeData, stateKey, tableContents, setTypeGroup, activeSetType, componentInstance, 
            lookupValues, currentUser, incrementTempID, tabs, activeTab, portalType, customComponentOnClickAdd, showRowName
        } = this.props;
        const { currentPage, resultsPerPage } = this.state;
        let nextTempID = 0;
             if(!showRowName && tabs && tabs.length > 0) {
                nextTempID = tabs[activeTab].nextTempID;
                if (nextTempID === undefined) {
                    nextTempID = 0;
                    tabs[activeTab].nextTempID = nextTempID;
                }
            }
        
        let tableContentsCopy: any = tableContents ? createCopyOfTableContents(tableContents) : [];
        let newItem: any;

        if(customComponentOnClickAdd){
            customComponentOnClickAdd();
        } else {
            newItem = getNewItem(componentInstance, nextTempID, currentUser, portalType, lookupValues, activeSetType, setTypeGroup,showRowName);
            if (newItem != null) {
                tableContentsCopy.push(newItem);
            }
            changeData(tableContentsCopy, stateKey);
            incrementTempID()

            this.updateContentsTable((currentPage - 1) * resultsPerPage, ((currentPage - 1) * resultsPerPage) + resultsPerPage, resultsPerPage, currentPage);
        }
    };

    onOpenCodeModel = (submission: string, type: string) => {
        const { showWorkSubmissionDetail, hideModal } = this.props;
        const field = JSON.stringify(JSON.parse(submission), null, 2)
        const props: ISubmissionPromptViewModalProps = {
            hideCallback: () => { hideModal() },
            field: field === 'null' ? '' : field,
            title: type
        }
        showWorkSubmissionDetail(submission, props);
    }

    renderLineBreak = (array: string[]) => {
        return (
            <div>
                {array.map((item, index) => (
                    <div key={index}>
                        {item}
                        {index + 1 !== array.length ? <span>,</span> : null}
                    </div>
                ))}
            </div>
        );
    }

    renderFieldOptions(field: IRepertoireField, tableContentItem: any, index: number): JSX.Element {
        const {
            dataGridTableData,
            stateKey,
            isReadOnly,
            dataSource,
            lookupValues,
            showModal,
            addNewAccount,
            openInNewTab,
            openInSplitScreen,
            expandedWorkResults,
            expandMatchingWork,
            expandedProductResults,
            expandMatchingProduct
        } = this.props;
        return (stateKey === 'matchingRepertoireWorks' && (!expandedWorkResults || !expandedWorkResults.includes(index)) ?
           <td className="td" title={field.data}>
                <img
                    src={EXTERNAL_SVG}
                    title="Expand title"
                    alt="Right Arrow icon"
                    className={expandedWorkResults && expandedWorkResults.includes(index) ? "arrowIconExpanded" : "arrowIcon"}
                    onClick={() => expandMatchingWork(index)}
                />
                <FieldOptions
                    dataGridTableData={dataGridTableData}
                    stateKey={stateKey}
                    isReadOnly={isReadOnly}
                    dataSource={dataSource}
                    lookupValues={lookupValues}
                    field={field}
                    tableContentItem={tableContentItem}
                    index={index}
                    showModal={showModal}
                    showSearchModal={this.showSearchModal}
                    addNewAccount={addNewAccount}
                    changeTableData={this.changeTableData}
                    openInNewTab={openInNewTab}
                    openInSplitScreen={openInSplitScreen}
                /></td> :
            stateKey === 'matchingRepertoireWorks' && (expandedWorkResults && expandedWorkResults.includes(index)) ?
                <td className="td" title={field.data}>
                    <img
                        src={EXTERNAL_SVG}
                        title="Expand title"
                        alt="Right Arrow icon"
                        className={expandedWorkResults && expandedWorkResults.includes(index) ? "arrowIconExpanded" : "arrowIcon"}
                        onClick={() => expandMatchingWork(index)}
                    />
                    <FieldOptions
                        dataGridTableData={dataGridTableData}
                        stateKey={stateKey}
                        isReadOnly={isReadOnly}
                        dataSource={dataSource}
                        lookupValues={lookupValues}
                        field={field}
                        tableContentItem={tableContentItem}
                        index={index}
                        showModal={showModal}
                        showSearchModal={this.showSearchModal}
                        addNewAccount={addNewAccount}
                        changeTableData={this.changeTableData}
                        openInNewTab={openInNewTab}
                        openInSplitScreen={openInSplitScreen}
                    />
                    <TextDataInput
                        value={tableContentItem.name.length >= 2 ? tableContentItem.name[1].value : ''}
                        fieldName={stateKey}
                        changeData={null}
                        readOnly={true}
                        isHidden={false}
                    />
                    <TextDataInput
                        value={tableContentItem.name.length >= 3 ? tableContentItem.name[2].value : ''}
                        fieldName={stateKey}
                        changeData={null}
                        readOnly={true}
                        isHidden={false}
                    />
                </td> :
                stateKey === 'matchingRepertoireProducts' && (!expandedProductResults || !expandedProductResults.includes(index)) ?
                    <td className="td" title={field.data}>
                        <img
                            src={EXTERNAL_SVG}
                            title="Expand title"
                            alt="Right Arrow icon"
                            className={expandedProductResults && expandedProductResults.includes(index) ? "arrowIconExpanded" : "arrowIcon"}
                            onClick={() => expandMatchingProduct(index)}
                        />
                        <FieldOptions
                            dataGridTableData={dataGridTableData}
                            stateKey={stateKey}
                            isReadOnly={isReadOnly}
                            dataSource={dataSource}
                            lookupValues={lookupValues}
                            field={field}
                            tableContentItem={tableContentItem}
                            index={index}
                            showModal={showModal}
                            showSearchModal={this.showSearchModal}
                            addNewAccount={addNewAccount}
                            changeTableData={this.changeTableData}
                            openInNewTab={openInNewTab}
                        />
                    </td> :
                    stateKey === 'matchingRepertoireProducts' && (expandedProductResults && expandedProductResults.includes(index)) ?
                        <td className="td" title={field.data}>
                            <img
                                src={EXTERNAL_SVG}
                                title="Expand title"
                                alt="Right Arrow icon"
                                className={expandedProductResults && expandedProductResults.includes(index) ? "arrowIconExpanded" : "arrowIcon"}
                                onClick={() => expandMatchingProduct(index)}
                            />
                            <FieldOptions
                                dataGridTableData={dataGridTableData}
                                stateKey={stateKey}
                                isReadOnly={isReadOnly}
                                dataSource={dataSource}
                                lookupValues={lookupValues}
                                field={field}
                                tableContentItem={tableContentItem}
                                index={index}
                                showModal={showModal}
                                showSearchModal={this.showSearchModal}
                                addNewAccount={addNewAccount}
                                changeTableData={this.changeTableData}
                                openInNewTab={openInNewTab}
                            />
                            <TextDataInput
                                value={tableContentItem.name.length >= 2 ? tableContentItem.name[1].value : ''}
                                fieldName={stateKey}
                                changeData={null}
                                readOnly={true}
                                isHidden={false}
                            />
                            <TextDataInput
                                value={tableContentItem.name.length >= 3 ? tableContentItem.name[2].value : ''}
                                fieldName={stateKey}
                                changeData={null}
                                readOnly={true}
                                isHidden={false}
                            />
                        </td> :
                        stateKey === 'metadatamagazineLevyCopyCriteria' && (tableContentItem && tableContentItem.lastReview) ?
                        <td className="td" title={field.data}>
                            <div className="arrowIconDiv">
                                <img
                                src={RIGHT_ARROW_SVG}
                                title="Expand title"
                                alt="Right Arrow icon"
                                className={"arrowIconExpanded"}
                                // onClick={e => onExpand(index, e)}
                                />
                            </div>
                            {/* <FieldOptions
                                dataGridTableData={dataGridTableData}
                                stateKey={stateKey}
                                isReadOnly={isReadOnly}
                                dataSource={dataSource}
                                lookupValues={lookupValues}
                                field={field}
                                tableContentItem={tableContentItem}
                                index={index}
                                showModal={showModal}
                                showSearchModal={this.showSearchModal}
                                addNewAccount={addNewAccount}
                                changeTableData={this.changeTableData}
                                openInNewTab={openInNewTab}
                            /> */}
                        </td> :
                        <td className="td" title={tableContentItem[field.name].value ? tableContentItem[field.name].value : field.data} >
                            <FieldOptions
                                dataGridTableData={dataGridTableData}
                                stateKey={stateKey}
                                isReadOnly={isReadOnly}
                                dataSource={dataSource}
                                lookupValues={lookupValues}
                                field={field}
                                tableContentItem={tableContentItem}
                                index={index}
                                showModal={showModal}
                                showSearchModal={this.showSearchModal}
                                addNewAccount={addNewAccount}
                                changeTableData={this.changeTableData}
                                openInNewTab={openInNewTab}
                            />
                        </td>
        );
    }

    getHeaderSections = () => {
        const {
            dataGridTableData,
            componentInstance,
            showRowNumber,
            allowMultiSelectChbk,
            isBulkCheckboxActive,
            usageType,
            tableContents,
            activeSetType,
            checkableColumns = [],
            isRowSelectionEnabled = false,
            showRowName,
            isProductMaintenanceAccordionCore,
        } = this.props;

        const { activeSortHeaderSection, checkedColumns } = this.state;

        return buildHeaderSections({
            dataGridTableData,
            componentInstance,
            showRowNumber,
            allowMultiSelectChbk,
            isBulkCheckboxActive,
            usageType,
            tableContents,
            activeSetType,
            checkableColumns,
            isRowSelectionEnabled,
            activeSortHeaderSection,
            checkedColumns,
            ascending: this.ascending,
            showRowName,
            isProductMaintenanceAccordionCore,
            sortTableByColumn: this.sortTableByColumn,
            handleHeaderCheckboxChange: this.handleHeaderCheckboxChange,
            changeDataForLivePerformance: this.changeDataForLivePerformance,
            changeTableDataForMultiSelect: this.changeTableDataForMultiSelect,
        });
    };

    showSearchModal = (modalProps: any, searchViewKey: string, index?: number) => {
        const { showModal, componentInstance, dataSource, stateKey, dataGridTableData } = this.props;
        const modalViewData = dataGridTableData.fields.filter(f => f.componentInstance === MODAL_VIEW);

        if(stateKey!==IP_REPRESENTATION_KEY && stateKey!=='draftAgreementsApplicableWorks'){
            clearModalSearchResults();
        }

        if (componentInstance == PRODUCT_WORKS_KEY && dataSource == DataSource.Repertoire) {
            searchViewKey = PRODUCT_WORKS_REPERTOIRE_STATE_KEY;
        }
        else if (componentInstance == COMPONENTS_KEY && dataSource == DataSource.Repertoire) {
            searchViewKey = COMPONENTS_WORKS_REPERTOIRE_STATE_KEY;
        }
        else if (componentInstance == USAGE_MATCHING_WORKS_SECTION_KEY && stateKey == MATCHINGWORKS_KEY) {
            searchViewKey = USAGE_MATCHING_WORKS_SECTION_KEY;
        }
        else if (componentInstance == USAGE_MATCHING_WORKS_SECTION_KEY && stateKey == MATCHINGPRODUCTS_KEY) {
            searchViewKey = USAGE_MATCHING_PRODUCTS_SECTION_KEY;
        }
        if (searchViewKey == USAGE_MATCHING_WORKS_SECTION_KEY) {
            showModal(USAGESEARCH_VIEW, USAGE_MATCHING_WORKS_SECTION_KEY, modalProps, true, "Search Work To Match");
        }
        else if (searchViewKey == USAGE_MATCHING_PRODUCTS_SECTION_KEY) {
            showModal(SEARCH_VIEW, USAGE_MATCHING_PRODUCTS_SECTION_KEY, modalProps, true, "Search Product To Match");
        }
        else if ((stateKey === IP_REPRESENTATION_KEY || stateKey === CONTRIBUTORS_KEY) && searchViewKey === 'Territory Include') {
            showModal(TERRITORY_SELECTION_VIEW, stateKey, modalProps, true, "Territory Include", '', false, '', index)
        }
        else if ((stateKey === IP_REPRESENTATION_KEY || stateKey === CONTRIBUTORS_KEY) && searchViewKey === 'Territory Exclude') {
            showModal(TERRITORY_SELECTION_VIEW, stateKey, modalProps, true, "Territory Exclude", null, null, null, index)
        }
        else if (stateKey === IP_REPRESENTATION_KEY && searchViewKey === 'Pools Exclude') {
            showModal(POOL_SELECTION_VIEW, null, modalProps, true, "Pools Exclude", null, null, null, index)
        }
        else if (stateKey === IP_REPRESENTATION_KEY && searchViewKey === 'Pools Include') {
            showModal(POOL_SELECTION_VIEW, null, modalProps, true, "Pools Include", null, null, null, index)
        }
        else if (stateKey === "draftAgreementsComments"){
            const modalHeader = modalViewData.find(f => f.name === "commentsModalHeader")?.data || "Comments";
            showModal(DRAFT_AGREEMENTS_PAGE_VIEW, DRAFT_AGREEMENTS_PAGE_VIEW, modalProps, true, modalHeader, '', false, 'modalSearch', index);
        }
        else if (stateKey === "DraftAgreementsMaintenanceAssigneeView"){
            const modalHeader = modalViewData.find(f => f.name === "searchIPModalHeader")?.data || "Select IP";
            showModal(SEARCH_VIEW, 'ips', modalProps, true, modalHeader, '', false, 'agreementsAssignee', index);
        }
        else if(stateKey === USAGE_MAINTENANCE_GRIDS_VIEW_COMMENTS_STATE_KEY){
            showModal(USAGE_MAINTENANCE_COMMENTS_MODAL, USAGE_MAINTENANCE_COMMENTS_MODAL, modalProps, true, "Comment Details", '', false, '', index);
        }
        else if (stateKey === AGREEMENT_CARVEOUTS_KEY) {
            showModal(SEARCH_VIEW, AGREEMENT_CARVEOUT_PRODUCTS_KEY, modalProps, true, "Search Product");
        }
        else {
            const modalHeader = modalViewData.find(f => f.name === "searchViewModalHeader")?.data || "Search";
            showModal(SEARCH_VIEW, searchViewKey, modalProps, true, modalHeader, null, null, null, index);
        }
    };

    dependentRowAction(tableContentItem: any, event?: React.MouseEvent): void {
        const { dependentRowAction } = this.props;
        dependentRowAction(tableContentItem, event);
    }

    renderRowAction = (tableContentItem: any, field: IRepertoireField): JSX.Element => {
        const {
            stateKey,
            componentInstance,
            isReadOnly,
            tabs,
            activeTab,
            tableActions,
        } = this.props;

        return renderTableRowAction({
            tableContentItem,
            field,
            stateKey,
            componentInstance,
            isReadOnly,
            tabs,
            activeTab,
            tableActions,
            onClickOpen: this.onClickOpen,
            onClickAdd: this.onClickAdd,
            onClickRemove: this.onClickRemove,
            showSearchModal: this.showSearchModal,
            dependentRowAction: this.dependentRowAction.bind(this),
            onOpenCodeModel: this.onOpenCodeModel,
            renderGroupedActions: renderGroupedRowActions,
            mergeActionClick: this.props.mergeActionClick,
            groupActionClick: this.props.groupActionClick,
        });
    };

    renderGroupedActions = (tableContentItem: any, field: IRepertoireField): JSX.Element => {
        return renderGroupedRowActions({
            tableContentItem,
            field,
            groupActionClick: this.props.groupActionClick,
        });
    }

    renderTableActions = () => {
        const { tableActions } = this.props;
        return (<div>
            {tableActions && tableActions.map((ta, index) => this.renderTableAction(ta, index))}
        </div>);
    }

    renderTableAction = (tableAction: ITableAction, index: number) => {
        const {
            componentInstance,
            dataGridTableData,
            isReadOnly,
            openWorkFlow,
            tableContents,
            onClickCopy = () => {},
        } = this.props;

        return renderDataGridTableAction({
            tableAction,
            index,
            componentInstance,
            dataGridTableData,
            isReadOnly,
            openWorkFlow,
            tableContents,
            onClickAdd: this.onClickAdd,
            onClickCopy,
            showSearchModal: this.showSearchModal,
        });
    };

    renderHeader = () => {
        const {
            isExpandable
        } = this.props
        let sections = this.getHeaderSections();
        return <tr key="headerRow" className="tr">{isExpandable && <td />}{sections}</tr>;
    };

    handleDrop = (newOrder, e, droppedOnItem, tableContents) => {
        newOrder = newOrder - 1;

        e.target.classList.remove('js-active');
        const droppeddItem: IRepertoireField = JSON.parse(e.dataTransfer.getData('text/plain'));

        const dataTableFields: IRepertoireField[] = tableContents.filter(x => x.componentInstance === CONTRIBUTORS_KEY);

        let originalFieldPosition: number = 0;
        for (var i = 0; i < dataTableFields.length; i++) {
            if (dataTableFields[i].name === droppeddItem.name) {
                originalFieldPosition = i;
                break;
            }
        }

        this.changeTableData(droppedOnItem, EDITABLE_FIELDS_GRID, SEQUENCE_FIELD, originalFieldPosition, EDITABLE_FIELDS_GRID, newOrder);
    }

    handleDragLeave = (index, e, tableContentItem, tableContents) => {
        e.target.classList.remove('js-active');
    }

    handleDragEnd = (index, e, tableContentItem, tableContents) => {
        e.preventDefault();
        e.target.classList.add('js-active');
    }

    handleDragEnter = (index, e, tableContentItem, tableContents) => {
        e.preventDefault();
        e.target.classList.add('js-active');
    }

    handleDragOver = (index, e, tableContentItem, tableContents) => {
        e.preventDefault();
        e.target.classList.add('js-active');
    }

    handleDragStart = (index, e, draggedItem, tableContents) => {
        e.dataTransfer.setData('text/plain', JSON.stringify(draggedItem));
    }

    updateContentsTable(indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number): void {
        const { componentInstance, updateUserPreferences, allResultsPerPage } = this.props;
        this.setState({ indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage });        
        updateUserPreferences?.(allResultsPerPage, [], undefined, undefined, undefined,  indexOfFirstResult, indexOfLastResult, resultsPerPage, componentInstance);
    }

    renderPaginationView(): JSX.Element {
        const { tableContents, componentInstance, dataGridTableData } = this.props;
        const { resultsPerPage, currentPage } = this.state;
        const paginationData = dataGridTableData.fields.filter(f => f.componentInstance === PAGINATION);
        
        return <PaginationView
            contentsLength={tableContents ? tableContents.length : 0}
            resultsPerPage={resultsPerPage}
            currentPage={currentPage}
            updateContentsTable={this.updateContentsTable.bind(this)}
            componentInstance={componentInstance}
            paginationData={paginationData}
        />
    }

    renderTableContents = () => {
        const {
            tableContents,
            paginatedTableContents,
            addUsageDetailsRowData,
            onUpdateUsageRowDetails,
            isExpandedUsageMatchingSection,
            componentInstance,
            customFields,
            pool,
            dataGridTableData,
            isExpandable,
            stateKey,
            changeData,
            expandedUsageDetailsRow,
            addUsageDetailsShareIPRow,
            lookupValues,
            showModal,
            portalType,
            resetMessageBanner,
            openWorkFlow,
            currentPage: currentPageFromProps,
            resultsPerPage: resultsPerPageFromProps,
        } = this.props;

        const { focusedRow, currentPage, resultsPerPage } = this.state;

        return buildTableContents({
            tableContents,
            paginatedTableContents,
            addUsageDetailsRowData,
            onUpdateUsageRowDetails,
            isExpandedUsageMatchingSection,
            componentInstance,
            customFields,
            pool,
            dataGridTableData,
            isExpandable,
            stateKey,
            changeData,
            expandedUsageDetailsRow,
            addUsageDetailsShareIPRow,
            lookupValues,
            showModal,
            portalType,
            resetMessageBanner,
            openWorkFlow,
            focusedRow,
            currentPage,
            resultsPerPage,
            currentPageFromProps,
            resultsPerPageFromProps,
            enableCustomField: this.props.enableCustomField,
            clearAllRowsButThis: this.props.clearAllRowsButThis?.bind(this),
            getTableSections,
            renderRowAction: this.renderRowAction.bind(this),
            renderFieldOptions: this.renderFieldOptions.bind(this),
            changeTableData: this.changeTableData.bind(this),
            showSearchModal: this.showSearchModal.bind(this),
            onClickOpen: this.onClickOpen.bind(this),
            onRowClick: this.onRowClick,
            dependentRowAction: this.dependentRowAction.bind(this),
            updateIpRepresentationsIdsToRemove: this.updateIpRepresentationsIdsToRemove.bind(this),
            handleDrop: this.handleDrop.bind(this),
            handleDragLeave: this.handleDragLeave.bind(this),
            handleDragEnd: this.handleDragEnd.bind(this),
            handleDragEnter: this.handleDragEnter.bind(this),
            handleDragOver: this.handleDragOver.bind(this),
            handleDragStart: this.handleDragStart.bind(this),
            propsForTableSections: this.props,
        });
    };

    renderTableContentByComponent() {
        const { componentInstance } = this.props;

        if (componentInstance === EDITABLE_FIELDS_GRID) {
            return (
                <div className="dragContainer">
                    {this.renderTableContents()}
                </div>
            )
        }
        else {
            return (
                <tbody key="body" className="tbody ">
                    {this.renderTableContents()}
                </tbody>
            )
        }
    }

    renderTableByComponent() {
        const { componentInstance, stateKey } = this.props;
        if (componentInstance === EDITABLE_FIELDS_GRID) {
            return (
                <>
                    <table className={["table", stateKey].join(" ")}>
                        <thead key="thead" className={"thead"}>
                            {this.renderHeader()}
                        </thead>
                    </table>
                    {this.renderTableContentByComponent()}
                </>
            )
        }
        else {
            return (
                <>                    
                    <table className={["table", stateKey].join(" ")}>
                        <thead key="thead" className={"thead"}>
                            {this.renderHeader()}
                        </thead>
                        {this.renderTableContentByComponent()}
                    </table>
                    {['numbers', TITLES_KEY, POOL_WEIGHT_SETTINGS_KEY].includes(componentInstance) && this.renderPaginationView()}
                </>
            )
        }
    }

    render() {
        const { componentInstance } = this.props;
        let className: string = 'tableContainerModal';

        if (componentInstance === 'contributors') {
            className = 'tableContainer';
        }

        else if (componentInstance !== EDITABLE_FIELDS && componentInstance !== EDITABLE_FIELDS_GRID && componentInstance !== EDITABLE_DATA_FIELDS_CONFIGURATION_GRID && componentInstance !== DRAFT_AGREEMENTS_COMMENTS_STATE_KEY) {
            className = 'row tableContainer';
        }

        const isEditableTable = (componentInstance === EDITABLE_FIELDS || componentInstance === EDITABLE_FIELDS_GRID || componentInstance === EDITABLE_DATA_FIELDS_CONFIGURATION_GRID) ? true : false;

        return (
            <>
                <div id={'data-grid-table-' + componentInstance } key="table" className={className} ref={this.componentRef}>
                    <ListenToShortCutKeysDataGridTable
                        showSearchModal={this.showSearchModalShortCutKey.bind(this)}
                        addRow={this.addRowShortCutKeys.bind(this)}
                        deleteRow={this.deleteRowShortCutKeys.bind(this)}
                        handleClickOutside={this.handleClickOutside.bind(this)} />
                <div className={`col-md-12 ${componentInstance}`}>
                        {this.renderTableByComponent()}
                    </div>
                </div>
                <If condition={!isEditableTable}>
                    <div key="actions container" className="row tableContainer">
                        {this.renderTableActions()}
                    </div>
                </If>
            </>
        );
    }
}